import GivingFormEditor from './GivingFormEditor';

export default GivingFormEditor;
